export class CdRdStages {

    // Проектная документация
    static ProjectDocumentation = 1;

    // Рабочая документация
    static WorkingDocumentation = 2;
}